import { render, staticRenderFns } from "./Step3-Type1-Content.vue?vue&type=template&id=5b72871e&"
import script from "./Step3-Type1-Content.vue?vue&type=script&lang=js&"
export * from "./Step3-Type1-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports